"use client";

import React from "react";
import { Typography, Box } from "@mui/material";
import planet from '../../assets/integration/planet.png';
import background from '../../assets/backoffice/background.png';
import Grid from '@mui/material/Grid2';
import ecb from '../../assets/integration/ecb.png';
import emarchantpay from '../../assets/integration/emarchantpay.png';
import fraudlabs from '../../assets/integration/fraudlabs.png';
import paysafe from '../../assets/integration/paysafe.png';
import sumsub from '../../assets/integration/sumsub.png';
import trust from '../../assets/integration/trust.png';
import xe from '../../assets/integration/xe.png';


const IntegrationOptions: React.FC = () => {

    const integrations = [
        {
            id: 1,
            image: trust,
            xs: 6,
            md: 3
        },
        {
            id: 2,
            image: paysafe,
            xs: 6,
            md: 3
        },
        {
            id: 3,
            image: xe,
            xs: 6,
            md: 3
        },
        {
            id: 4,
            image: ecb,
            xs: 6,
            md: 3
        },
        {
            id: 5,
            image: fraudlabs,
            xs: 12,
            md: 4
        },
        {
            id: 6,
            image: emarchantpay,
            xs: 6,
            md: 4
        },
        {
            id: 7,
            image: sumsub,
            xs: 6,
            md: 4
        }
    ]


    return (
        <Grid container spacing={1} sx={{
            px: 1.5,
            display: "flex",
            maxWidth: "1440px",
            alignItems: "flex-start",
            gap: "6px",
            flexDirection: { md: "row", xs: "column" },
            alignSelf: "stretch",
        }}>
            <Grid size={{ xs: 12, md: 5 }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignSelf: "stretch",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        borderRadius: "12px",
                        backgroundColor: "lightPurple.200",
                        minWidth: "240px",
                        minHeight: { md: "712px", xs: "329px" },
                        padding: { md: "48px", xs: "24px 20px" },
                        width: "100%",
                        gap: { xs: "64px", md: "0px" },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignSelf: "flex-start",
                            gap: { md: "32px", xs: "20px" },
                        }}
                    >
                        <Box
                            component="img"
                            src={planet}
                            alt="Integration icon"
                            sx={{
                                aspectRatio: "1",
                                objectFit: "contain",
                                objectPosition: "center",
                                width: { xs: "60px", md: "80px" },
                                height: { xs: "60px", md: "80px" },
                            }}
                        />
                        <Typography
                            variant="h1"
                            sx={{
                                color: "darkPurple.500",
                            }}
                        >
                            Integration<br />options
                        </Typography>
                    </Box>
                    <Typography
                        variant="body7"
                        sx={{
                            color: "darkPurple.400",
                            textTransform: "uppercase",
                        }}
                    >
                        Our flexible APIs ensure seamless <br />integration with your
                        existing <br /> systems, so you stay ahead.
                    </Typography>
                </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 7 }} sx={{ backgroundColor: "darkPurple.500", borderRadius: "12px", }}>
                <Box
                    sx={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        alignSelf: "stretch",
                        minHeight: { md: "712px", xs: "460px" },
                        backgroundImage: `url(${background})`,
                        backgroundSize: "cover",
                    }}
                >
                    <Grid container spacing={1} sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                        alignSelf: "stretch",
                        alignContent: "center",
                        flexShrink: 0,
                        width: "100%",
                        padding: "16px",
                    }}>
                        {integrations.map((section) => (
                            <Grid size={{ xs: section.xs, md: section.md }} key={section.id} >
                                <Box
                                    sx={{
                                        display: "flex",
                                        gap: "8px",
                                        flex: 1,
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: "darkPurple.400",
                                        height: "142.5px",
                                        width: "100%",
                                        overflow: "hidden", 
                                        mixBlendMode: "luminosity"
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={section.image}
                                        alt="Integration icon"
                                        sx={{
                                            maxWidth: "100%",
                                            maxHeight: "80%",
                                            objectFit: "contain",
                                            padding: "16px",
                                            background: section.image 
                                        }}
                                    />
                                    </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Grid>
        </Grid>
    );
};

export default IntegrationOptions;
